import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

export default function ProtectedRoute({ allowedRoles, children }) {
  const { userRole } = useUser();

  // // اگر لاگین نکرده
  // if (!userRole) {
  //   return <Navigate to="/7777" replace />;
  // }

  // // اگر نقشش مجاز نیست
  // if (!allowedRoles.includes(userRole)) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  return children;
}
